import { Feature } from "ol";
import { Geometry } from "ol/geom";
import ReportStrategy from "./report.strategy";
import StoppageReportStrategy from "./stoppage-report.strategy";
import SpeedReportStrategy from "./speed-report.strategy";
import IDeviceStore from "@/models/modelStore/IDeviceStore";

export default class ConsolidatedReportStrategy extends ReportStrategy {

    stoppingReport: StoppageReportStrategy
    speedReport: SpeedReportStrategy

    constructor(report: any, data: any, device: IDeviceStore) {
        super(report, data, device)
        this.stoppingReport = new StoppageReportStrategy(report, data, device)
        this.speedReport = new SpeedReportStrategy(report, data, device)
    }

    async getExtraFeatures(): Promise<Feature<Geometry>[]> {
        return [...await this.stoppingReport.getExtraFeatures(), ...await this.speedReport.getExtraFeatures()]
    }

}